import { m } from '../../motif/m';

export const paginationDarkBgVars = {
  '--pagination-item-color': m('--action-text-default-color'),
  '--pagination-item-hover-color': m('--action-text-hover-color'),
  '--pagination-item-active-color': m('--action-text-active-color'),
  '--pagination-indicator-hover-color': m('--action-indicator-hover-color'),
  '--pagination-indicator-active-color': m('--action-indicator-active-color'),
};

export const paginationLightBgVars = {
  '--pagination-item-color': m('--action-text-default-color'),
  '--pagination-item-hover-color': m('--action-text-hover-color'),
  '--pagination-item-active-color': m('--action-text-active-color'),
  '--pagination-indicator-hover-color': m('--action-indicator-hover-color'),
  '--pagination-indicator-active-color': m('--action-indicator-active-color'),
};
